"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPrintSettings(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm3.5 2.625h-.875v-1.75a.82666.82666 0 0 1 .875-.875h7a.82666.82666 0 0 1 .875.875v1.75h-.875v-1.75h-7zm.875 6.125h3.85388a4.97515 4.97515 0 0 0 -.60321.875h-3.25067zm8.84967-5.25a.82448.82448 0 0 0 -.09967 0h-12.25a.82667.82667 0 0 0 -.875.875v5.25a.8267.8267 0 0 0 .875.875h1.75v2.625a.8267.8267 0 0 0 .875.875h3.92212a4.96024 4.96024 0 0 1 -.28412-.875h-3.638v-5.25h5.679a4.97041 4.97041 0 0 1 4.821-.45288v-3.04712a.82664.82664 0 0 0 -.77533-.875zm-.09967 1.75a.875.875 0 0 1 -1.75 0 .87642.87642 0 1 1 1.75 0zm-5.87061 5.25a4.94486 4.94486 0 0 0 -.1914.875h-2.68799v-.875zm8.74561 2.2124v-1.4274l-1.101-.222a3.03 3.03 0 0 0 -.18811-.45136l.62091-.93493-1.00892-1.00929-.93274.61981a3.0302 3.0302 0 0 0 -.45618-.19067l-.22052-1.09381h-1.42688l-.22056 1.09381a3.02382 3.02382 0 0 0 -.45856.19183l-.92883-.61725-1.00887 1.00928.619.932a3.02709 3.02709 0 0 0 -.19019.45739l-1.0932.22052v1.42731l1.09955.2218a3.03072 3.03072 0 0 0 .18945.45179l-.62085.93481 1.009 1.00928.93982-.62458a3.024 3.024 0 0 0 .44715.186l.22234 1.10326h1.42688l.22327-1.10748a3.02577 3.02577 0 0 0 .44427-.18585l.94037.62493 1.00891-1.00927-.625-.9411a3.02879 3.02879 0 0 0 .18634-.44629zm-4 .807a1.52338 1.52338 0 1 1 1.52289-1.5234 1.52316 1.52316 0 0 1 -1.52289 1.52341z' })));
}
exports.default = SvgPrintSettings;
